// src/services/socketService.js

import moment from 'moment';
import { io } from 'socket.io-client';
import Vue from 'vue';
import eventBus from './eventBus';

let socket;

export const socket_connected = Vue.observable({ value: false });

export const connectSocket = (associate) => 
{
    let socket_endpoint = process.env.VUE_APP_WEBSOCKETS_LOCAL

    if (process.env.VUE_APP_ENVIRONMENT === 'local') 
    {
        socket_endpoint = process.env.VUE_APP_WEBSOCKETS_LOCAL
    } 
    else if (process.env.VUE_APP_ENVIRONMENT === 'dev') 
    {
        socket_endpoint = process.env.VUE_APP_WEBSOCKETS_DEV
    } 
    else if (process.env.VUE_APP_ENVIRONMENT === 'prod') 
    {
        socket_endpoint = process.env.VUE_APP_WEBSOCKETS_PROD
    }

    if (socket && socket.connected) {
        console.log('Socket is already connected');
        return;
    }

    socket = io(socket_endpoint, {
        query: { associate_id: associate.id, facility: associate.facility_name, facility_id: associate.facility_id, date: moment().format("MM-DD-YY"), name: associate.name, from: 'Web', token: localStorage.getItem('access_token') ? `${localStorage.getItem('access_token')}` : '' }, // Pass user ID as a query parameter
    });

    socket.on('connect', () => {
        socket_connected.value = true
        eventBus.$emit('assignment_complete')
        eventBus.$emit('header_notifications')
        eventBus.$emit('message_dashboard')
        eventBus.$emit('assignment_status')
        eventBus.$emit('dashboard')
    });

    socket.on('disconnect', () => {
        socket_connected.value = false
        console.log('Disconnected from WebSocket server');
    });
};

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};

export const changeAssignmentForAssignmentComplete = (assignment_id) => {
    if (socket) {
        socket.emit('changeAssignmentForAssignmentComplete', assignment_id);
    }
};

export const changeDateForAssignmentStatus = (date) => {
    if (socket) {
        socket.emit('changeDateForAssignmentStatus', date);
    }
};

export const emitInspectionCompletedForDashboard = (facility_id) => {
    if (socket) {
        socket.emit('emitInspectionCompletedForDashboard', facility_id);
    }
};

export const emitDischargesForDashboard = (facility_id) => {
    if (socket) {
        socket.emit('emitDischargesForDashboard', facility_id);
    }
};

export const emitRoomsCleanedForDashboard = (facility_id) => {
    if (socket) {
        socket.emit('emitRoomsCleanedForDashboard', facility_id);
    }
};

export const getSocket = () => socket;
